import { __awaiter, __generator } from "tslib";
import { fetchOfficeComponentContext } from '@office-start/component-context-service';
import { fetchFeatureSettings, getFeatureSettings, } from '@office-start/feature-settings-service';
import { fetchUserEntitlements, getUserEntitlements, } from '@office-start/user-entitlements-service';
export function fetchIsCopilotRoute() {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var componentContext, isCopilotRoute;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, fetchOfficeComponentContext()];
                case 1:
                    componentContext = _b.sent();
                    isCopilotRoute = ((_a = componentContext === null || componentContext === void 0 ? void 0 : componentContext.browserPathAndQueryString) === null || _a === void 0 ? void 0 : _a.includes('/copilot')) ||
                        false;
                    return [2 /*return*/, isCopilotRoute];
            }
        });
    });
}
export function fetchIsCopilotAMode() {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var featureSettingsResult, featureSettings, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    featureSettingsResult = getFeatureSettings();
                    if (!(featureSettingsResult === null || featureSettingsResult === void 0 ? void 0 : featureSettingsResult.result)) return [3 /*break*/, 1];
                    _c = featureSettingsResult;
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, fetchFeatureSettings()];
                case 2:
                    _c = _d.sent();
                    _d.label = 3;
                case 3:
                    featureSettings = _c;
                    return [2 /*return*/, ((_b = (_a = featureSettings === null || featureSettings === void 0 ? void 0 : featureSettings.result) === null || _a === void 0 ? void 0 : _a.copilot) === null || _b === void 0 ? void 0 : _b.mode) === 'ModeA'];
            }
        });
    });
}
export function fetchPinningEligible() {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function () {
        var userEntitlementsResult, userEntitlements, _d, eligibility;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    userEntitlementsResult = getUserEntitlements();
                    if (!(userEntitlementsResult === null || userEntitlementsResult === void 0 ? void 0 : userEntitlementsResult.result)) return [3 /*break*/, 1];
                    _d = userEntitlementsResult;
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, fetchUserEntitlements()];
                case 2:
                    _d = _e.sent();
                    _e.label = 3;
                case 3:
                    userEntitlements = _d;
                    eligibility = (_a = userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.result) === null || _a === void 0 ? void 0 : _a.userCopilotEligibilityV3;
                    return [2 /*return*/, !!(((_b = userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.result) === null || _b === void 0 ? void 0 : _b.isCommercialUser) &&
                            (eligibility === null || eligibility === void 0 ? void 0 : eligibility.isCopilotEligible) &&
                            (eligibility === null || eligibility === void 0 ? void 0 : eligibility.cohort) !== 'BCAIS' &&
                            ((_c = eligibility === null || eligibility === void 0 ? void 0 : eligibility.pinningEligibility) === null || _c === void 0 ? void 0 : _c.includes('M365')))];
            }
        });
    });
}
export function fetchBCAIS() {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function () {
        var userEntitlementsResult, userEntitlements, _d, eligibility;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    userEntitlementsResult = getUserEntitlements();
                    if (!(userEntitlementsResult === null || userEntitlementsResult === void 0 ? void 0 : userEntitlementsResult.result)) return [3 /*break*/, 1];
                    _d = userEntitlementsResult;
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, fetchUserEntitlements()];
                case 2:
                    _d = _e.sent();
                    _e.label = 3;
                case 3:
                    userEntitlements = _d;
                    eligibility = (_a = userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.result) === null || _a === void 0 ? void 0 : _a.userCopilotEligibilityV3;
                    return [2 /*return*/, !!(((_b = userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.result) === null || _b === void 0 ? void 0 : _b.HasCopilotBusinessChat) ||
                            (((_c = userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.result) === null || _c === void 0 ? void 0 : _c.isCommercialUser) &&
                                (eligibility === null || eligibility === void 0 ? void 0 : eligibility.isCopilotEligible) &&
                                (eligibility === null || eligibility === void 0 ? void 0 : eligibility.cohort) === 'BCAIS'))];
            }
        });
    });
}
export function fetchCopilotEligible() {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var userEntitlementsResult, userEntitlements, _b, eligibility;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    userEntitlementsResult = getUserEntitlements();
                    if (!(userEntitlementsResult === null || userEntitlementsResult === void 0 ? void 0 : userEntitlementsResult.result)) return [3 /*break*/, 1];
                    _b = userEntitlementsResult;
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, fetchUserEntitlements()];
                case 2:
                    _b = _c.sent();
                    _c.label = 3;
                case 3:
                    userEntitlements = _b;
                    eligibility = (_a = userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.result) === null || _a === void 0 ? void 0 : _a.userCopilotEligibilityV3;
                    return [2 /*return*/, !!(eligibility === null || eligibility === void 0 ? void 0 : eligibility.isCopilotEligible)];
            }
        });
    });
}
//# sourceMappingURL=fetchIsCopilotRoute.js.map